import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/lysep_logo.svg" alt="LYSEP CORPORATION Logo" className="footer-logo-image" />
              <div className="footer-logo-text">
                <h3 className="footer-logo-short"><span className="lysep-text">LYSEP</span></h3>
                <h3 className="footer-logo-full"><span className="lysep-text">LYSEP</span><span className="corp-text">CORPORATION</span></h3>
              </div>
            </div>
            <p className="footer-description">
              Teknoloji ve inovasyonun öncüsü olarak, geleceği şekillendiren çözümler sunuyoruz.
            </p>
            <div className="social-links">
              <a href="https://www.instagram.com/lysepcode" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                <span>@lysepcode</span>
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Hızlı Linkler</h4>
            <ul className="footer-links">
              <li><Link to="/">Ana Sayfa</Link></li>
              <li><Link to="/about">Hakkımızda</Link></li>
              <li><Link to="/services">Hizmetler</Link></li>
              <li><Link to="/projects">Projelerimiz</Link></li>
              <li><Link to="/contact">İletişim</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Hizmetler</h4>
            <ul className="footer-links">
              <li><Link to="/services#otomotiv-cozumleri">Otomotiv Çözümleri</Link></li>
              <li><Link to="/services#arac-gizli-ozellik-acma">Araç Gizli Özellik Açma</Link></li>
              <li><Link to="/services#obd-screen">OBD Screen</Link></li>
              <li><Link to="/services#yazilim-cozumleri">Yazılım Çözümleri</Link></li>
              <li><Link to="/services#web-siteleri">Web Siteleri</Link></li>
              <li><Link to="/services#qr-menu-sistemleri">QR Menü Sistemleri</Link></li>
              <li><Link to="/services#masaustu-uygulama">Masaüstü Uygulama</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>İletişim Bilgileri</h4>
            <div className="footer-contact">
              <p>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                info@lysep.com
              </p>
             
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2018 LYSEP CORPORATION. Tüm hakları saklıdır.</p>
            <div className="footer-bottom-links">
              {/* <a href="#">Gizlilik Politikası</a>
              <a href="#">Kullanım Şartları</a>
              <a href="#">Çerez Politikası</a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
